module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAASFBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTqblzhQ0zwjmf9zn/ymWv/2YPfOUj0pG/seWD5uXfoY1j3rnPjTlDuhGT7xHvmWVQ7eJ3dAAAACHRSTlMAYL//ACDP71kzCuAAAAD6SURBVHgB7ZdBj4MgEEaRUQvCNxbXtv//ny6NGxIOHnDmYDa8E4nJ4zAvmDGdzv9lsCTADmPGjOM0k5B5+oqmB4l5TFk0kwLzaAZSYTCWTnCOGrDm5INfQlh8g+lMRBGIpCFyITgVkWf2clHhqohZSeSckmhdr7ZUixjgiy3VoifwvNhSLUpAam6pFm0/mYRM+p629pZMuRyF4CRT2xP+SLts/BwPT2RpR+4QOXFH6yFaxR0BeL0ASDva8P4Qfd7YJB1l4sKU4SVWb1K7yJeDdGqFG4kkj1z/r91m/F3URV1kSQWrt0KoLTV6a5ba4pdRWkXl3E7URV30C5/PPnfCCL8fAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1e8-1f1f3.png
// module id = 588
// module chunks = 0